/**
 * ONBOARDING PENCERESİ — F-PPL-09
 *
 * ================================================================
 * NEDEN BURADA: SABİT VARDI AMA KİMSE KULLANMIYORDU
 * ================================================================
 * `ONBOARDING_GUN = 14` sunucuda tanımlıydı ve 04.09.2026'da ölçüldü:
 * **yalnızca kendi testinde** kullanılıyordu. Üretim kodunun ikisi de
 * sayıyı elle yazıyordu — biri sabitin **yanı başında**
 * (`sonTarih(ogrenci.createdAt, 14)`), diğeri panelde iki ayrı cümlede
 * ("İlk 14 günlük pencere kapandı").
 *
 * Bu, sabitin hiç olmamasından KÖTÜ: okuyan `ONBOARDING_GUN` görüp tek
 * doğruluk kaynağı sanıyor ve aramayı bırakıyor. `21` yazsan hiçbir şey
 * değişmezdi — servis 14 uygulamaya devam eder, panel 14 yazar, test
 * bile geçerdi (`gunSonra <= ONBOARDING_GUN` gevşer, sıkılaşmaz).
 *
 * Şimdi sayı sözleşmede ve pencereyi hesaplayan fonksiyon **gün sayısı
 * parametresi almıyor**. CLAUDE.md kural 10: koruma unutulabilecek bir
 * yere değil işin kendisine bağlanır — yanlış sayı geçirilebilen bir
 * imza dururken "doğru sayıyı geçmeyi unutma" bir koruma değildir.
 */

/** Kayıttan sonraki onboarding penceresi (gün). Şartnamenin sayısı. */
export const ONBOARDING_GUN = 14;

/**
 * Bir maddenin son tarihi.
 *
 * `gunSonra` madde başına değişir (3, 5, 7…), o yüzden burada parametre
 * KALIYOR. Pencerenin kendisi için aşağıdaki fonksiyon kullanılır.
 */
export function onboardingSonTarih(kayitTarihi: Date, gunSonra: number): Date {
  const d = new Date(kayitTarihi.getTime());
  d.setUTCDate(d.getUTCDate() + gunSonra);
  return d;
}

/** Onboarding penceresinin bitiş anı. Gün sayısı DIŞARIDAN VERİLEMEZ. */
export function onboardingPenceresiBitisi(kayitTarihi: Date): Date {
  return onboardingSonTarih(kayitTarihi, ONBOARDING_GUN);
}

/** Pencere kapandı mı — sunucu ve arayüz aynı cevabı verir. */
export function onboardingPenceresiKapandiMi(kayitTarihi: Date, simdi: Date): boolean {
  return onboardingPenceresiBitisi(kayitTarihi).getTime() < simdi.getTime();
}

/**
 * Arayüzün cümlesi de buradan.
 *
 * Panel "İlk 14 günlük pencere" diye ELLE yazıyordu; sayı değişse metin
 * eski kalırdı ve kullanıcıya yanlış söylenirdi — sessizce, çünkü hiçbir
 * şey patlamaz.
 */
export const ONBOARDING_PENCERE_METNI = `ilk ${ONBOARDING_GUN} gün`;
